'use strict';

/**
 *
 * @category   View
 * @module     settings
 * @copyright  Copyright (c) 2015, COLIDO (http://www.colido.net)
 * @author     Cengiz Mardin <cm@humans.am>
 */

var LayoutView = require('base/Colido.LayoutView');
var template = require('modules/settings/templates/layout/information/client-informations.hbs');

var ClientInformationsLayout = LayoutView.extend({
    template: template,

    className: 'settings settings-client-informations',
});

module.exports = ClientInformationsLayout;